import React, {useState} from "react";
import {connect} from "react-redux";
import Col from "@prism/col";
import Row from "@prism/row";
import Section from "../../common/Section";
import {ViewPhotoButton} from "./ViewPhotoButton";
import DeleteDamageButton from "./DeleteDamageButton";
import EditDamageButton from "./EditDamageButton";
import {deleteDamage} from "../../../actions/conditionActions";
import {showAddEditDamage} from "../../../actions/globalDisplayActions";

import CapturePhotoButton from "./CapturePhotoButton";
import DamageImageModal from "./DamageImageModal";
import {getActiveImage} from "../../../actions/damageImageActions";
import {
  isAutomatedDamage,
  damageRequiresPhoto,
  isPricingEmptyWithValidAction
} from "../../../utils/utils";
import { useCameraCapture } from "../../../hooks/useCameraCapture";
import * as pricingUtils from "./PricingUtils"
import {FYU_DAMAGE_ANALYSIS} from "../../../utils/constants";
import "../../../styles/damage-panel.css"

const DamageLineItem = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleDeleteDamage = () => {
    props.deleteDamage(props.damage, props.condition);
  };

  const handleEditDamage = () => {
    const damage = props.damage
    console.log(`Edit ${damage.item} ${damage.damage} line item clicked for damageId ${damage.damageId}`)
    props.showAddEditDamage(damage);
  };

  const showImage = () => {
    setModalOpen(true);
  };

  const toggleModal = () => {
    setModalOpen((prevState) => !prevState);
  };

  const { damage, condition } = props;
  const { workOrderNumber } = props.workOrderInfo;
  const {vin} = props.designatedDescription
  const isCRSO = pricingUtils.isCRSO(condition)

  const { handleCapturePhoto } = useCameraCapture({
    workOrderNumber,
    vin
  });

  const isAutoDamage = isAutomatedDamage(props.automatedDamages, damage.damageKey)

  const editingDisabled = !isCRSO && isAutoDamage;
  const invalidRow = ((isCRSO && isPricingEmptyWithValidAction(damage)) || (damageRequiresPhoto(damage, condition.conditionType) && !damage.hasImage)) ? 'invalid-row' : '';

  return (
    <Section heading={damage.item}
             containerBodyClass="pt-0"
             id={"item-" + damage.damageId}
             suggestedDamage={damage.sourcePlatform === FYU_DAMAGE_ANALYSIS}
             isAutoDamage={isAutoDamage}
    >
      <DamageImageModal
        showModal={modalOpen}
        toggle={toggleModal}
        imageTitle={damage.item}
        damageKey={damage.damageKey}
        damageId={damage.damageId}
        damage={damage}
        getActiveImage={props.getActiveImage}
        conditionType={condition.conditionType}
      />

      <Col className={`damage-summary-row ${invalidRow} ${editingDisabled ? " disabled" : ""}`}>

        <Row>
          <Col className="damage-summary-col">
            <label id={"damage-" + damage.damageId}>{damage.damage}</label>
          </Col>
          <Col className="damage-summary-col">
            <label id={"severity-" + damage.damageId}>{damage.severity}</label>
          </Col>
        </Row>

        <Row className="damage-summary-buttons py-2">
          <Col className="left">
            <DeleteDamageButton
                disabled={isAutoDamage}
                damage={damage}
                onClick={handleDeleteDamage}
            />
          </Col>
          <Col className="central">
            {damage.hasImage ? (
                <ViewPhotoButton
                    onClick={showImage}
                    disabled={false}
                    id={"view-image-" + damage.damageId}
                    className="my-0"
                />
            ) : (
                <CapturePhotoButton
                    id={"capture-image-" + damage.damageId}
                    className="my-0"
                    onClick={() => handleCapturePhoto(damage.damageId, damage.item)}
                />
            )}
          </Col>
          <Col className="right">
            <EditDamageButton
                id={"edit-" + damage.damageId}
                onClick={handleEditDamage}
                disabled={editingDisabled}
            />
          </Col>
        </Row>
      </Col>
    </Section>
  );
};

const matchDispatchToProps = {
  deleteDamage,
  showAddEditDamage,
  getActiveImage,
};

function mapStateToProps({ automatedDamages, workOrderInfo, condition, designatedDescription }) {
  return { automatedDamages, workOrderInfo, condition, designatedDescription };
}

export default connect(mapStateToProps, matchDispatchToProps)(DamageLineItem);
